// extracted by mini-css-extract-plugin
export default {"container":"cK-z","disabled":"dK-z","bgBlack":"eK-z","content":"fK-z","countdown":"gK-z","topCaption":"hK-z","topHeading":"iK-z","heading":"jK-z","copy":"kK-z"};